import { createContext, useContext, type ReactNode } from "react";
import { useChatHistory } from "../hooks/useChatHistory";
import type { ChatListItem } from "../types";

interface ChatHistoryContextType {
    chats: ChatListItem[];
    isLoading: boolean;
    error: string | null;
    refetch: () => Promise<void>;
}

const ChatHistoryContext = createContext<ChatHistoryContextType | null>(null);

export function ChatHistoryProvider({ enabled, children }: { enabled: boolean; children: ReactNode }) {
    const value = useChatHistory(enabled);
    return <ChatHistoryContext.Provider value={value}>{children}</ChatHistoryContext.Provider>;
}

export function useChatHistoryContext() {
    const context = useContext(ChatHistoryContext);
    if (!context) {
        throw new Error("useChatHistoryContext must be used within ChatHistoryProvider");
    }
    return context;
}
